<div class="header-mainInfo">
    <div style="line-height: 1.2; padding-top: 2px;">
        {{unidad.nombre}} <br>
        <small style="font-weight: normal; opacity: 0.6;">
            {{unidad.materias.length > 0 ? unidad.materias.length.toString() : 'Sin'}} materia{{unidad.materias.length
            != 1 ? 's' : ''}}
            <button class="md-14" type="button" mat-icon-button [matMenuTriggerFor]="menuMaterias">
                <mat-icon *ngIf="!menuMaterias.menuOpen">arrow_drop_down</mat-icon>
                <mat-icon *ngIf="menuMaterias.menuOpen">arrow_drop_up</mat-icon>
            </button>
        </small>
        <mat-menu #menuMaterias="matMenu" yPosition="below" [overlapTrigger]="false">
            <ng-container *ngFor="let materia of unidad.materias">
                <button mat-menu-item>
                    <span>{{materia.nombreCompleto}}</span>
                </button>
            </ng-container>
        </mat-menu>
        <span style="opacity: 0.6;">
            <small>{{unidad.clasesEsperadas}} clases del </small>
            <small>{{unidad.fechaInicia | date: 'd MMM yyyy'}}</small>
            <small>&nbsp;al&nbsp;</small>
            <small>{{unidad.fechaFin | date: 'd MMM yyyy'}}</small>
            <span class="">&nbsp;&nbsp;</span>
        </span>
        <span *ngIf="unidad.alumnosIEP.length > 0">
            <small class="IEP">IEP</small>
        </span>
    </div>
</div>